import React, { useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";

import {
  useCountProductFeedbackMutation,
  useFetchProductFeedbackMutation,
} from "../../../features/tenant/feedbackProduct/feedBackProductApi";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { render } from "@testing-library/react";
import view from "../../../assests/tenant/images/view.svg";
import hide from "../../../assests/tenant/images/hide.svg";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";

const AppProductFeedBack = () => {
  const location = useLocation();

  const [
    FetchProductFeedback,
    {
      data: FetchProductFeedbackData,
      error: FetchProductFeedbackError,
      isLoading: FetchProductFeedbackIsLoading,
      isError: FetchProductFeedbackIsError,
    },
  ] = useFetchProductFeedbackMutation();

  const [
    CountProductFeedback,
    {
      data: CountProductFeedbackData,
      error: CountProductFeedbackError,
      isLoading: CountProductFeedbackIsLoading,
      isError: CountProductFeedbackIsError,
    },
  ] = useCountProductFeedbackMutation();

  const [
    FetchCsvProductFeedback,
    {
      data: FetchCsvProductFeedbackData,
      error: FetchCsvProductFeedbackError,
      isLoading: FetchCsvProductFeedbackIsLoading,
      isError: FetchCsvProductFeedbackIsError,
    },
  ] = useFetchProductFeedbackMutation();

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const currentDate = new Date().toISOString().split("T")[0];
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
  const [appUsers, setAppUsers] = useState(appUserTypes);
  const [feedback, setFeedback] = useState([]);
  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });
  const [image, setImage] = useState("")
  const [showImage, setShowImage] = useState(false)
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const initialRequest = {
    user_type_id: userTypeId,
    limit: 10,
    offset: 0,
    mobile: "",
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);

  useEffect(() => {
    console.log("Product", FetchProductFeedbackData)
    if (FetchProductFeedbackData?.body?.feedbackList) {
      setFeedback(FetchProductFeedbackData.body.feedbackList);
    }
  }, [FetchProductFeedbackData]);

  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element.user_type.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  useEffect(() => {
    fetchProductFeedbackFunction();
    fetchCountProductFeedbackFunction();
    // fetchFetchCsvFeedbackFunction();
  }, [location.pathname, limit, offset, userTypesArray]);

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
  };

  useEffect(() => { }, [request]);
  const fetchProductFeedbackFunction = (row) => {
    FetchProductFeedback({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchCountProductFeedbackFunction = (row) => {
    CountProductFeedback({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchCsvProductFeedbackFunction = (row) => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    FetchCsvProductFeedback({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
    });
  };
  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (FetchProductFeedbackData && FetchProductFeedbackData.body.feedbackList) {
      setCsvData(FetchProductFeedbackData.body.feedbackList);
    }

    if (FetchCsvProductFeedbackError) {
      setCsvData(null);
    }
  }, [FetchCsvProductFeedbackData, FetchCsvProductFeedbackError]);

  // FetchCsvFeedback

  const clearFilters = () => {
    setRequest(initialRequest);
  };
  useEffect(() => {
    if (
      request.mobile === "" &&
      request.user_type_id === userTypeId &&
      request.startDate === "" &&
      request.endDate === currentDate
    ) {
      fetchProductFeedbackFunction();
      // fetchFetchCsvFeedbackFunction();
    }
  }, [request, userTypeId]);

  const handleProductImage = (row) => {
    setShowImage(!showImage)
    setImage(row.image)
  };

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => <div>{row.name}</div>,
      sortable: true,
    },

    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
    },
    {
      name: "UserType",
      cell: (row) => row.user_type,
      sortable: true,
    },
    {
      name: "Product Code",
      cell: (row) => row.product_code,
      sortable: true,
    },
    {
      name: "Product Code",
      cell: (row) => row.product_name,
      sortable: true,
    },
    {
      name: "Rating",
      cell: (row) => row.rating,
      sortable: true,
    },
    {
      name: "Image",
      width: "150px",
      cell: (row) => {
        if (
          !row.image
        ) return (<></>)
        return (
          <>
            <button
              type="button"
              className="bg-black p-1 rounded-sm"
            >
              <img
                src={view}
                alt=""
                onClick={() =>
                  handleProductImage(row)
                }
              />
            </button>


          </>
        )
      }
    },
    {
      name: "Feedback",
      cell: (row) => row.feedback,
      sortable: true,
      width: "300px",
    }
    // {
    //   name: "Status",
    //   cell: (row) => (row.status == "1" ? <>Blocked</> : <>unBlocked</>),
    // }
  ];
  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Product FeedBack
            <LinksComponent />
          </div>

          <div className="p-3 ">
            <div className="flex justify-between items-start">
              {/* {FetchCsvFeedbackData && FetchCsvFeedbackData?.body?.feedbackList && (
                <ExportCSV
                  data={FetchCsvFeedbackData && FetchCsvFeedbackData?.body?.feedbackList}
                  columnsToExport={[
                    "name",
                    "mobile",
                    "user_type",
                    "rating",
                    "feedback"
                  ]}
                />
              )} */}

              <div className="mb-2">
                <CustomExport
                  fetchData={fetchCsvProductFeedbackFunction}
                  data={csvData}
                  defaultColumnExport={[
                    "name",
                    "mobile",
                    "user_type",
                    "rating",
                    "feedback",
                  ]}
                  filename="app_feedback"
                />
              </div>
            </div>

            <div className=" w-full bg-white shadow rounded-lg">
              <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex  space-x-2 ">
                  <div className="w-52 ">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile No
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="Mobile..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 ">
                    <div className="flex-col slc_dvd topslt">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        User Types
                      </label>
                      <div className="relative searchin">
                        {appUsers && appUsers.length > 0 && (
                          <SelectComponent
                            className="capitalize"
                            // title={"User Types"}
                            selected={userTypesArray}
                            setSelected={setUserTypesArray}
                            dataArr={appUsers}
                          />
                        )}{" "}
                      </div>
                    </div>
                  </div>

                  <div className="w-52 ">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        From Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="Start Date"
                        value={request.startDate}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              startDate: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 ">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="End Date"
                        value={request.endDate}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              endDate: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      &nbsp;
                    </label>

                    <div className="flex flex-row  gap-2 ">
                      <div className="relative searchin">
                        <button
                          className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                          onClick={() => {
                            fetchProductFeedbackFunction();

                            // fetchFetchCsvFeedbackFunction();
                          }}
                        >
                          Search
                        </button>
                      </div>
                      <div className="relative searchin">
                        <button
                          className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                          onClick={() => {
                            clearFilters();
                          }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <DataTableComponent
                  keyField={(row) => row.SNo}
                  columns={columns}
                  data={feedback.length && feedback}
                  totalRows={
                    CountProductFeedbackData && CountProductFeedbackData.body.total_feedback
                  }
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paginationDefaultPage={currentPage}
                  paginationResetDefaultPage={paginationResetToggle}
                ></DataTableComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showImage && (
        <ImageModal
          show={
            showImage
              ? true
              : false
          }
          setShow={setShowImage}
          size="md"
          data={
            image
          }
        >
          <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
            <img
              src={
                image
              }
              alt="product-image"
              className="h-full w-full object-cover object-center group-hover:opacity-75"
            />
          </div>
        </ImageModal>
      )}
    </>
  );
};

export default AppProductFeedBack;
